import { s_subscribe, s_unsubscribe } from "badmfck-signal"
import { useState, useEffect } from "react"

export const useResize=()=>{
    const [size,setSize]=useState({width:window.innerWidth,height:window.innerHeight})
    useEffect(()=>{
      const callbackID=s_subscribe((e)=>{
        setSize({width:e.width,height:e.height})
      },"resize")
      return ()=>{
        s_unsubscribe(callbackID)
      }
    },[])
    return size
  }